/** 项目文档初始状态。 */
const initialProjectDocumentState = {
    projectId: null,
    document: null,
    status: 'idle',
    errorMessage: null,
    isDirty: false,
};
/** 标记项目文档开始加载。 */
export function projectDocumentLoadStarted(payload) {
    return { type: 'projectDocument/loadStarted', payload };
}
/** 写入后端返回的完整项目文档。 */
export function projectDocumentLoaded(payload) {
    return { type: 'projectDocument/loaded', payload };
}
/** 记录项目文档加载失败。 */
export function projectDocumentLoadFailed(payload) {
    return { type: 'projectDocument/loadFailed', payload };
}
/** 清理当前项目工作区。 */
export function projectDocumentCleared() {
    return { type: 'projectDocument/cleared' };
}
/** 替换当前项目的完整文档编辑副本。 */
export function projectDocumentReplaced(document, meta = {}) {
    return { type: 'projectDocument/replaced', payload: document, meta: { editedAt: Date.now(), ...meta } };
}
/** 把独立保存成功后的设置同步回工作区文档。 */
export function projectDocumentSettingsSynced(payload) {
    return { type: 'projectDocument/settingsSynced', payload };
}
/** 标记完整项目文档保存开始。 */
export function projectDocumentSaveStarted(payload) {
    return { type: 'projectDocument/saveStarted', payload };
}
/** 清除已经成功提交的文档脏状态。 */
export function projectDocumentSaved(payload) {
    return { type: 'projectDocument/saved', payload };
}
/** 记录保存失败并保留本地文档，供后续重试。 */
export function projectDocumentSaveFailed(payload) {
    return { type: 'projectDocument/saveFailed', payload };
}
/** 根据动作更新项目文档工作区，保持完整文档是唯一编辑副本。 */
export function projectDocumentReducer(state = initialProjectDocumentState, action) {
    switch (action.type) {
        case 'projectDocument/loadStarted':
            return {
                projectId: action.payload.projectId,
                document: null,
                status: 'loading',
                errorMessage: null,
                isDirty: false,
            };
        case 'projectDocument/loaded':
            return {
                projectId: action.payload.projectId,
                document: action.payload.document,
                status: 'ready',
                errorMessage: null,
                isDirty: false,
            };
        case 'projectDocument/loadFailed':
            return {
                projectId: action.payload.projectId,
                document: null,
                status: 'error',
                errorMessage: action.payload.errorMessage,
                isDirty: false,
            };
        case 'projectDocument/cleared':
            return initialProjectDocumentState;
        case 'projectDocument/replaced':
            return {
                ...state,
                document: action.payload,
                status: 'ready',
                errorMessage: null,
                isDirty: true,
            };
        case 'projectDocument/settingsSynced':
            if (state.projectId !== action.payload.projectId || state.document === null)
                return state;
            return {
                ...state,
                document: { ...state.document, settings: action.payload.settings },
                errorMessage: null,
            };
        case 'projectDocument/saveStarted':
            if (state.projectId !== action.payload.projectId ||
                state.document !== action.payload.document)
                return state;
            return { ...state, status: 'saving', errorMessage: null };
        case 'projectDocument/saved':
            if (state.projectId !== action.payload.projectId ||
                state.document !== action.payload.document)
                return state;
            return { ...state, status: 'ready', errorMessage: null, isDirty: false };
        case 'projectDocument/saveFailed':
            if (state.projectId !== action.payload.projectId ||
                state.document !== action.payload.document)
                return state;
            return {
                ...state,
                status: 'error',
                errorMessage: action.payload.errorMessage,
                isDirty: true,
            };
        default:
            return state;
    }
}
